<template>
  <div>
    <div class="modal hide fade" id="modalAccountSaldo" tabindex="-1" role="dialog" aria-labelledby="modalAccountSaldo" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header red darken-3 text-left text-white">
              <h4 class="modal-title w-100 font-weight-bold">Account Saldo</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <form>
                <div class="form-group">
                  <label for="request_edit" class="col-form-label">Product:</label>
                  <input type="text" v-model="saldo.product_no" class="form-control">
                </div>
                <div class="form-group">
                  <label for="request_edit" class="col-form-label">Method</label>
                  <select class="form-control" v-model="saldo.method">
                    <option value="debet">Debit</option>
                    <option value="credit">Credit</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="request_edit" class="col-form-label">Date</label>
                  <datetime v-model="saldo.saldo_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                </div>
                <div class="form-group">
                  <label for="request_edit" class="col-form-label">Saldo</label>
                  <input type="text" v-model="saldo.saldo" v-money="money" class="form-control form-control-right"/>
                </div>
              </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartOfAccountModal',
  props: ['accountSaldo'],
  data () {
    return {
      saldo: {
        id: null,
        account_code: null,
        saldo: null,
        saldo_date: null,
        method: 'debet',
        product_no: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  watch: {
    accountSaldo: {
      immediate: true,
      handler (newValue) {
        this.saldo = newValue
      }
    }
  },
  methods: {
    save () {
      this.$emit('saveAccountSaldo', this.saldo)
      this.saldo = {
        id: null,
        account_code: null,
        saldo: null,
        saldo_date: null,
        method: null,
        product_no: null
      }
    }
  }
}
</script>
